import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
  Image,
} from "@mantine/core";

import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import {
  IconArrowBigDownFilled,
  IconAt,
  IconBolt,
  IconBoltFilled,
  IconExchange,
  IconFileInvoice,
  IconRocket,
} from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";

export const SENDING_LIGHTNING_PAYMENTS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      When you first start Rizful, you'll find that you can't send lighting
      payments. This button will be disabled:
    </p>
    <DocsButton
      ariaLabel="send lightning"
      text="Send Lightning"
      leftSection={<IconBoltFilled />}
      disabled={true}
    />
    <p>
      In order to send payments, you need outbound capacity. We have{" "}
      <a href="/docs/balances-and-capacities#outbound-capacity">
        a couple suggestions
      </a>{" "}
      on the most convenient ways to get outbound capacity.
    </p>
    <p>
      Once you have outbound capacity, you can send payments. The Send Lightning
      button will be enabled:
    </p>
    <DocsButton
      ariaLabel="send lightning"
      text="Send Lightning"
      leftSection={<IconBoltFilled />}
      disabled={false}
    />
    When you click that, you'll find three options:
    <ol>
      <li>Pay to lightning address</li>
      <li>Pay to lightning invoice</li>
      <li>Pay using keysend</li>
    </ol>
  </TypographyStylesProvider>
);
